import React from 'react';
import { connect } from 'react-redux';
import { formatDate } from 'helpers/stringUtils';
import { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
// import { Link } from 'react-router-dom';
import config from 'config/api';
import DynamicForm from 'components/UI/DynamicForm';
// import BlockButton from "components/UI/BlockButton";
import Button from '@material-ui/core/Button';
import i18n from 'helpers/i18n';
import { withRouter } from 'react-router-dom';
import { getDataHome } from '../../ducks/asyncFetcher';
const styles = (theme) => {
  return {
    root: {},
    padder: {
      padding: '20px 40px',
      margin: '0 30px 20px',
    },
    summary: {
      width: '100%',
      backgroundColor: theme.palette.primary.main,
      color: '#fff',
      '& .MuiTypography-h5': {
        color: '#fff',
        marginBottom: theme.spacing(2),
      },
      '& .MuiTypography-body1': {
        color: '#fff',
        marginBottom: theme.spacing(2),
      },
    },
    // h5: {
    //   textAlign: "center",
    // },
    // h6: {
    //   fontWeight: "normal",
    // },
    // body1: {
    //   textAlign: "center",
    // },
    padderClass: {
      padding: '20px 0',
      '&>div': {
        maxWidth: 800,
      },
    },
    groupClass: {
      marginBottom: 5,
    },
  };
};
class RegistrationForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      formComplete: false,
      // formComplete: true,
      logMessage: false,
    };
    this._onFormComplete = this._onFormComplete.bind(this);
  }
  _onFormComplete(responseData) {
    // console.log('COMPLETe', this.props.onFormComplete)
    const logMessage = responseData.accountJob === 'st' ? 'st' : 'md';
    if (this.props.onFormComplete) this.props.onFormComplete(responseData);
    else
      this.setState({
        formComplete: true,
        logMessage: logMessage,
      });
  }
  render() {
    const { onClose, classes, extraFields, $$homeData, history } = this.props;
    //
    const { formComplete, logMessage } = this.state;
    const moduleConfig = {
      module: 'account',
      fetchUrl: config.registration + '/edit',
      postUrl: config.registration + '/edit',
      redirectAfterEdit: false,
      afterEdit: 'onFormComplete',
      afterEditLog: '',
      afterEditHideForm: true,
      btCancel: false,
      btSubmitLabel: 'Envoyer',
      fieldVariant: 'filled',
      buttonVariant: 'contained',
      buttonSubmitColor: 'secondary',
      // preActionsLegend: 'hello'
    };
    let fromEvents = extraFields.get('fromEvents');
    // console.log({fromEvents})
    let $$mainEvent = undefined;
    try {
      fromEvents = JSON.parse(fromEvents);
      // console.log('decoded', fromEvents)
      if ($$homeData !== undefined && fromEvents[0]) {
        $$mainEvent = $$homeData.get('availableEvents').find((e) => e.get('id') === fromEvents[0]);
        // console.log($$mainEvent.toJS())
      }
    } catch (e) {
      console.log('something failed, cannot guess main event!');
    }
    return (
      <Grid item xs={12} className={classes.root}>
        <If condition={formComplete !== true}>
          <Box align="left">
            <DynamicForm
              moduleConfig={moduleConfig}
              onFormComplete={this._onFormComplete}
              formFooter={
                <If condition={i18n.has('registrationFormFooter')}>
                  <div>{i18n.get('registrationFormFooter')}</div>
                </If>
              }
              extraFields={extraFields}
              padderClass={classes.padderClass}
              groupClass={classes.groupClass}
            />
          </Box>
        </If>
        <If condition={formComplete === true && !this.props.onFormComplete}>
          <Box py={8} px={4} className={classes.summary}>
            <Typography variant={'h5'} classes={{ root: classes.h5 }} gutterBottom>
              {i18n.get('registrationSuccessTitle', {
                substitute: {
                  '{date}':
                    $$mainEvent !== undefined
                      ? formatDate($$mainEvent.get('eventDate'), 'dddd dd mmmm yyyy') +
                        ' - ' +
                        formatDate($$mainEvent.get('eventDate'), "HH'h'MM")
                      : '',
                },
                pretty: true,
                element: 'span',
              })}
            </Typography>

            <If condition={logMessage === 'st'}>
              <Typography variant={'body1'} classes={{ root: classes.body1 }} gutterBottom>
                {i18n.get('registrationLogStudents')}{' '}
              </Typography>
            </If>
            <Typography variant={'body1'} classes={{ root: classes.body1 }} gutterBottom>
              {i18n.get('registrationSuccessText', {
                substitute: {
                  '{date}':
                    $$mainEvent !== undefined
                      ? formatDate($$mainEvent.get('eventDate'), 'dddd dd mmmm yyyy') +
                        ' - ' +
                        formatDate($$mainEvent.get('eventDate'), "HH'h'MM")
                      : '',
                },
                pretty: true,
                element: 'span',
              })}
            </Typography>

            <Button
              variant="contained"
              onClick={(e) => {
                e.preventDefault();
                history.push('/');
              }}
            >
              Retour à l'accueil
            </Button>
          </Box>
        </If>
      </Grid>
    );
  }
}

function mapStateToProps(state) {
  const props = {
    $$homeData: getDataHome(state),
  };
  return props;
}
export default withStyles(styles)(withRouter(connect(mapStateToProps)(RegistrationForm)));



// WEBPACK FOOTER //
// ./src/components/Registration/RegistrationForm.jsx